import { useCallback, useEffect, useState } from 'react'

/**
 * This is a hook replacement for the withViewportMeta HOC. This hook can calculate if a page has been scrolled to the
 * bottom or not (with cross-browser support).
 */
export const useViewportMeta = (offset = 0) => {
  const [windowWidth, setWindowWidth] = useState<number>(window.innerWidth)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [isScrolledToBottom, setIsScrolledToBottom] = useState<boolean>(false)

  const handleScroll = useCallback(() => {
    const scrollTop =
      (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop
    const scrollHeight =
      (document.documentElement && document.documentElement.scrollHeight) ||
      document.body.scrollHeight
    setIsScrolledToBottom(scrollTop + window.innerHeight >= scrollHeight - offset)
  }, [offset])

  useEffect(() => {
    if (!isLoading) {
      const scrollListener = () => handleScroll()
      window.addEventListener('scroll', scrollListener)

      return () => window.removeEventListener('scroll', scrollListener)
    }
    return
  }, [handleScroll, isLoading])

  useEffect(() => {
    if (!isLoading) {
      const handleResize = () => setWindowWidth(window.innerWidth)
      window.addEventListener('resize', handleResize)
      return () => window.removeEventListener('resize', handleResize)
    }
    return
  }, [isLoading])

  return {
    isScrolledToBottom,
    setIsLoading,
    windowWidth,
  }
}
